// src/lazy.ts
function determineLazyBehavior(options) {
  var hasBeenSelected = options.hasBeenSelected,
      isLazy = options.isLazy,
      isSelected = options.isSelected,
      _options$lazyBehavior = options.lazyBehavior,
      lazyBehavior = _options$lazyBehavior === void 0 ? "unmount" : _options$lazyBehavior;
  if (!isLazy) return true;
  if (isSelected) return true;
  if (lazyBehavior === "keepMounted" && hasBeenSelected) return true;
  return false;
}

export { determineLazyBehavior };